module.exports = __webpack_public_path__ + "assets/img/favicon/apple-icon-180x180.f4662c7fbc718200e6958c4465770a14.png";